import cn from "classnames";

import { convertValueToLocale } from "helpers/convertValueToLocale";

import { bottomText } from "./ObjectGrowthCard.config";

import { Typography } from "shared/ui/components/Typography";

import { DetailedTable } from "../DetailedTable";

import styles from "./ObjectGrowthCard.module.scss";

const renderValueByKey = (value: any, key: string) => {
  switch (key) {
    case "quantity":
      return convertValueToLocale(value, 2, "%");
    default:
      return value;
  }
};

const _cellRenderer = ({
  className,
  item,
  key,
  justifyContent,
  cellType,
  minWidth,
  maxWidth,
}) => {
  switch (key) {
    default: {
      const value =
        cellType !== "boolean" ? item[key] || "" : item[key] || false;

      return (
        <div
          className={cn(styles.cell, className)}
          key={key}
          style={{
            minWidth,
            maxWidth,
            justifyContent: justifyContent,
            padding: "8px 12px",
          }}
        >
          <Typography className={cn(styles.text)} variant="numbers">
            {renderValueByKey(value, key)}
          </Typography>
        </div>
      );
    }
  }
};

const ObjectGrowthCard = ({ items, columns }: any) => {
  return (
    <DetailedTable
      title="Annahmen"
      bottomText={bottomText}
      data={items}
      columns={columns}
      cellRenderer={(props) => _cellRenderer(props)}
    />
  );
};

export default ObjectGrowthCard;
